<script>
    let shown = false;
    export function show(){
        shown = true;
    }
    export function hide(){
        shown = false;
    }
</script>

<style>
    .modal-wrapper {
        background-color: rgb(0,0,0);
        background-color: rgb(0,0,0,0.5);
        position: fixed;
        width:100%;
        height: 100%;
        top:0;
        left:0;
        z-index: 4;
    }
    .modal {
        background-color: White;
        border-radius:6px;
        max-width: 37vw;
        padding: 1rem;
        margin: 2% auto;
        min-height: 40vh;
    }
    .close{
        float: right;
        cursor: pointer;
        width:24px;
    }
    .close:hover{
        font-weight: bold;
    }
    @media (max-width: 768px) {
    
	.modal{
		max-width:90%;
        margin-left:auto;
        margin-right: auto;
        margin-top: 3rem;
	}
    }
</style>
<svelte:window
on_keydown = { e=> {
if (e.keyCode == 27){
    hide();
}
}}/>
{#if shown}
    <div class="modal-wrapper">
        <div class="modal">
            <img src="./img/cerrar.svg" class="close" on:click={() => hide()} alt="">
            <slot />
        </div>
    </div>
{/if}